<!-- Gestão completa (Subcategorías) do cliente, reusada em modo embutido (contexto). -->
<app-subgrupo *ngIf="montado"
  [embutido]="true"
  [empresaContextoId]="clienteEmpresaId">
</app-subgrupo>
